import React from 'react';
import PropTypes from 'prop-types';
import style from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/ui_rel';

class MoreBtn extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={style.more}>
                <a href={content.link} target="_blank" rel={rel}>
                    点击查看更多
                </a>
            </div>
        );
    }
}

export default errorBoundary(MoreBtn);
